export { default } from './ForecastGraphSwellSpectraReadings';
